import { render, staticRenderFns } from "./Trapezoidal.vue?vue&type=template&id=201becbe&"
import script from "./Trapezoidal.vue?vue&type=script&lang=js&"
export * from "./Trapezoidal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Trapezoidal.vue"
export default component.exports